import request from '@/utils/request'

/**
 * 管理员登录
 * @param {{ username: string, password: string }} data
 * @returns {Promise<{ menus, auths, token: { token, expires_time } }>}
 */
export function login(data) {
  return request({
    url: 'login',
    method: 'post',
    data
  })
}

/** 管理员退出登录 */
export function logout() {
  return request({
    url: 'admin/login/out',
    method: 'get'
  })
}

/** 当前管理员信息 */
export function getAdminInfo() {
  return request({
    url: 'admin/info',
    method: 'get'
  })
}
